import { FC } from "react";
import styles from "./index.module.scss";
import cn from "classnames";

interface LogStatusProps {
  isPass: boolean;
}

const LogStatus: FC<LogStatusProps> = ({ isPass }) => {
  return (
    <div className={cn(styles.status, isPass ? styles.pass : styles.fail)}>
      {isPass ? "通过" : "失败"}
    </div>
  );
};

export default LogStatus;
